import React from 'react';

import BreakdownTable from '../shared/BreakdownTable';
import useOverallBreakdownData from './utils/useOverallBreakdownData';
import { EntityTypes } from 'context/entityContext';
import { IMetricExtended, IBreakdownsItem } from './../types';

interface IOverallPerformanceBreakdownTableProps {
  breakdownData: IBreakdownsItem[];
  isPending: boolean;
  entityType: EntityTypes;
  activeMetric: IMetricExtended;
}

const OverallPerformanceBreakdownTable: React.FC<IOverallPerformanceBreakdownTableProps> = (
  props
) => {
  const { breakdownData, isPending, entityType, activeMetric } = props;

  const breakdowns = useOverallBreakdownData(
    breakdownData,
    activeMetric.value,
    entityType
  );

  const secondHeader = `${activeMetric.label} (in album eq)`;

  return (
    <BreakdownTable
      headers={['consumption type', secondHeader]}
      breakdowns={breakdowns}
      isPending={isPending}
      activeMetric={activeMetric}
    />
  );
};

export default OverallPerformanceBreakdownTable;
